import { render, staticRenderFns } from "./SubmissionConfirmation.vue?vue&type=template&id=129883f0&scoped=true&"
import script from "./SubmissionConfirmation.vue?vue&type=script&lang=js&"
export * from "./SubmissionConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionConfirmation.vue?vue&type=style&index=0&id=129883f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129883f0",
  null
  
)

export default component.exports